<section>
  <div class="congratulations-icon"></div>
</section>
<br /><br />
<section>
  <h2>
    <div class="success-message">{{ successMessage }}</div>
  </h2>
  <ng-container
    *ngIf="
      isEnrolledInOLB || (!isEnrolledInOLB && credentialsCreatedSuccessfully)
    "
  >
    <br />
    <div class="success-page-content">
      {{ nextSteps }} {{ howToContact }} <b>{{ customerSupportPhone }}.</b>
    </div>
    <br />
  </ng-container>
  <br />
  <div class="multiple-products" *ngFor="let product of productsWithAccounts">
    <div
      [ngClass]="[
        'highlight-' + product.productType.toLowerCase(),
        'highlight'
      ]"
      [style]="
        product.productStripeColor
          ? 'background-color: #' + product.productStripeColor
          : ''
      "
    ></div>
    <div class="product-details">
      <div class="td-status-icon-area">
        <img alt="Green Checkbox" src="/assets/images/state-accepted.svg" />
      </div>
      <span fxFlex="33" class="product-name">
        <h3>{{ product.productName }}</h3>
      </span>
      <div fxFlex fxLayoutAlign="space-between center">
        <span *ngIf="product.accountAPYText"
          >{{ product.accountAPYText }}
        </span>
        <span *ngIf="!product.accountAPYText"
          >{{ product.productDescription }}% Annual Percentage Yield (APY)
        </span>
        <span data-dd-privacy="mask"
          ><b>{{ product.accountNumber }}</b></span
        >
      </div>
    </div>
  </div>
  <ng-container *ngIf="productsWithoutAccounts">
    <div
      class="multiple-products"
      *ngFor="let product of productsWithoutAccounts"
    >
      <div
        [ngClass]="[
          'highlight-' + product.productType.toLowerCase(),
          'highlight'
        ]"
        [style]="
          product.productStripeColor
            ? 'background-color: #' + product.productStripeColor
            : ''
        "
      ></div>
      <div class="product-details">
        <div class="td-status-icon-area">
          <img src="/assets/images/attention.svg" />
        </div>
        <span fxFlex="33" class="product-name">{{ product.productName }}</span>
        <div fxFlex fdLayoutAlign="space-between center">
          <span>{{ product.productDescription }}</span>
          <span class="account-number"></span>
        </div>
      </div>
    </div>
  </ng-container>
  <br />
  <div class="success-page-content">
    Rates accurate as of: {{ getEffectiveDate() }}
  </div>
  <br />
  <h3 *ngIf="!isEnrolledInOLB && credentialsCreatedSuccessfully && !isMinor">
    Username: <strong data-dd-privacy="mask">{{ username }}</strong>
  </h3>
</section>
<br />
<section>
  <app-technical-issue-message
    *ngIf="!isEnrolledInOLB && !credentialsCreatedSuccessfully"
    [tryAgainURL]="createCredentialsURL"
  ></app-technical-issue-message>
  <ng-container *ngIf="!hideLogin">
    <button mat-flat-button color="primary" class="primary-btn-action" (click)="navigateTo(loginUrl)">
      Log In
    </button>
  </ng-container>
  <ng-container *ngIf="showAuthenticatedAddJointArea && isBaskBrand">
    <div
      fxLayout="column"
      fxLayoutAlign="center center"
      fxLayoutGap="20px"
      id="add-joint-container"
    >
      <img
        src="./assets/images/bask/add-joint-owner.svg"
        alt="Add a joint account owner"
      />
      <p class="title">Your account is eligible to add a joint owner.</p>
      <button
        mat-stroked-button
        class="secondary-btn-action"
        color="primary"
        *ngIf="isJointOwnerFeatureEnabled"
        (click)="proceedToAddJoint()"
      >
        + JOINT OWNER
      </button>
      <p *ngIf="!isJointOwnerFeatureEnabled">
        {{ jointOwnerFeatureDisabledText }}
      </p>
    </div>
  </ng-container>
  <ng-container *ngIf="showDirectDepositArea">
    <mat-divider></mat-divider>
    <div
      fxLayout="column"
      fxLayoutAlign="center center"
      fxLayoutGap="20px"
      id="direct-deposit-container"
    >
      <p>{{ directDepositText }}</p>
      <button mat-stroked-button class="secondary-btn-action" color="primary" (click)="launchAtomicSdk()">
        Set Up Direct Deposit
      </button>
    </div>
  </ng-container>
</section>
